import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import ActionCreator from './../store/actions/index';
import { connect } from "react-redux";
import { compose } from "recompose";
import { Paper, Table, TableContainer, withStyles } from "@material-ui/core";
import TableHeader from "../components/Common/TableHeader";
import TableContent from "../components/ManageUsersComponents/TableContent";
import AddUser from "../components/ManageUsersComponents/AddUser/AddUser";
import UserDetailsDialog from "../components/ManageUsersComponents/UserDetailsDialog/UserDetailsDialog";
import t from "../languages/pl";
import { mapNewUserDto } from '../requests/mapApiObject';

const useStyles = theme => ({
  paper: {
    background: theme.palette.background.paper,
    margin: theme.spacing(1),
    padding: theme.spacing(2),
  },
  tableContainer: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    maxHeight: "78vh"
  },
  addUser: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }
});

const tableColumns = [
  t.emailAddressLabel,
  t.username,
  t.userType,
  t.carsQuantity,
  t.lastActivity,
  t.manage
];

const ManageUsersView = props => {
  const { classes, allUsers, userCars } = props;
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    props.getUsers();
  }, []);

  const handleAddUser = (userData) => props.addUser(mapNewUserDto(userData));

  const handleUserDetailsClick = (id) => {
    props.getUserCars(id);
    setUserData(allUsers.find(user => user.uzytkownik_id === id));
  };

  const handleUserDelete = id => {
    props.deleteUser(id);
    setUserData(null);
  };

  const handlePasswordReset = id => {
    props.resetUserPassword(id);
  };

  const handlePasswordExpirationChange = (id, value) => {
    props.changePasswordExpiration(id, value);
  };

  return (
    <Paper
      square
      className={classes.paper}
    >
      <div className={classes.addUser}>
        <AddUser
          onSubmit={handleAddUser}
        />
      </div>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader>
          <TableHeader data={tableColumns}/>
          <TableContent
            users={allUsers}
            onUserDetailsClick={handleUserDetailsClick}
          />
        </Table>
      </TableContainer>
      {
        userData !== null ?
          <UserDetailsDialog
            open={userData !== null}
            data={userData}
            cars={userCars}
            onClose={() => setUserData(null)}
            onSubmit={(values, id) => props.editUser(id, values)}
            onDelete={handleUserDelete}
            onPasswordReset={handlePasswordReset}
            onExpirationChange={handlePasswordExpirationChange}
            onCarsAssign={(id, carIds) => props.editUserCars(id, carIds)}
          /> : null
      }
    </Paper>
  );
};

const mapStateToProps = (state) => ({
  allUsers: state.userReducer.users,
  userCars: state.userReducer.userCars
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActionCreator, dispatch);
};


ManageUsersView.propTypes = {
  classes: PropTypes.object,
  //redux
  allUsers: PropTypes.array,
  userCars: PropTypes.array,
  getUsers: PropTypes.func,
  addUser: PropTypes.func,
  deleteUser: PropTypes.func,
  getUserCars: PropTypes.func,
  resetUserPassword: PropTypes.func,
  changePasswordExpiration: PropTypes.func,
  editUser: PropTypes.func,
  editUserCars: PropTypes.func
};

export default compose(
  withStyles(useStyles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ManageUsersView);
